import { render, staticRenderFns } from "./simOpenTn.vue?vue&type=template&id=ac323208&scoped=true&"
import script from "./simOpenTn.vue?vue&type=script&lang=js&"
export * from "./simOpenTn.vue?vue&type=script&lang=js&"
import style0 from "./simOpenTn.vue?vue&type=style&index=0&id=ac323208&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac323208",
  null
  
)

export default component.exports